// 抽象类型
const STRING = 'string'
const IMAGE = 'image'
const OBJECT = 'object'
const NUMBER = 'number'
const BOOLEAN = 'boolean'
const DATE_TIME = 'dateTime'
const ENUMERATION = 'enumeration'
const OBJECT_ARRAY = 'objectArray'
const FILE = 'file'

// 组件类定义
const APP_SINGLE_TEXT = 'internal-component-input--Input'
const APP_TEXT_AREA = 'internal-component-input--TextArea'
const APP_NUMBER = 'internal-component-input--InputNumber'
const APP_STEPPER = 'internal-component-input--Stepper'
const APP_IMAGE = 'internal-component-input--AppImage'
const APP_UPLOAD_IMAGE = 'internal-component-input--Uploader'
const APP_ATTACHMENT = 'internal-component-input--Attachment'

// 选项类
const APP_SWITCH = 'internal-component-input--Switch'
const APP_DROPDOWN = 'internal-component-input--Selector'
const APP_DROPDOWN_CHECKBOX = 'internal-component-input--MultipleSelector'
const APP_RADIO_BUTTONS = 'internal-component-input--Radio'
const APP_CHECKBOX = 'internal-component-input--Checkbox'
const APP_DATE_PICKER = 'internal-component-input--DatetimePicker'
const APP_CASCADER = 'internal-component-input--Cascader'

// 抽象类型名称
const TypeNameMap = {
    [STRING]: '文本',
    [NUMBER]: '数值',
    [ENUMERATION]: '枚举',
    [BOOLEAN]: '布尔值',
    [DATE_TIME]: '日期时间',
    [IMAGE]: '图片',
    [OBJECT]: '对象',
    [OBJECT_ARRAY]: '对象集合',
    [FILE]: '附件',
}

// Mock 演示数据类型
const MockTypeNameMap = {
    [STRING]: '文本',
    [NUMBER]: '数值',
    [ENUMERATION]: '枚举',
    [BOOLEAN]: '布尔值',
    [DATE_TIME]: '日期时间',
    [IMAGE]: '图片',
    [FILE]: '附件',
}

// 集成api可以映射的类型
const ApiTypeFilterMap = {
    string: [STRING, ENUMERATION, IMAGE, FILE],
    number: [NUMBER, ENUMERATION],
    integer: [NUMBER, ENUMERATION],
    boolean: [BOOLEAN],
    stringArray: [ENUMERATION, IMAGE],
    numberArray: [ENUMERATION],
    integerArray: [ENUMERATION],
}

// 集成api映射添加字段的规则
const ApiTypeFilterRules = {
    string: {
        defaultConfig: {
            type: 'string',
            // textType: 'short',
            textLengthRange: [0, 200],
            required: false,
            defaultComponent: APP_SINGLE_TEXT,
        },
        [STRING]: {
            componentsType: [APP_SINGLE_TEXT, APP_TEXT_AREA, APP_RADIO_BUTTONS, APP_DROPDOWN, APP_CASCADER],
        },
        [ENUMERATION]: {
            componentsType: [APP_RADIO_BUTTONS, APP_DROPDOWN],
            multiOptionDisabled: true,
            multiOption: false,
        },
        [IMAGE]: {
            componentsType: [APP_UPLOAD_IMAGE],
            singleImageDisabled: true,
            singleImage: true,
        },
        [FILE]: {
            componentsType: [APP_ATTACHMENT],
        },
    },
    number: {
        defaultConfig: {
            type: 'number',
            decimalDigit: null,
            minNum: '',
            maxNum: '',
            required: false,
            defaultComponent: APP_NUMBER,
        },
        [NUMBER]: {
            // componentsType: []
        },
        [ENUMERATION]: {
            componentsType: [APP_RADIO_BUTTONS, APP_DROPDOWN],
            multiOptionDisabled: true,
            multiOption: false,
        },
    },
    integer: {
        [NUMBER]: {
            // componentsType: []
            decimalDigitDisabled: true,
        },
        [ENUMERATION]: {
            componentsType: [APP_RADIO_BUTTONS, APP_DROPDOWN],
            multiOptionDisabled: true,
            multiOption: false,
        },
    },
    boolean: {
        defaultConfig: {
            type: 'boolean',
            defaultComponent: APP_SWITCH,
        },
        [BOOLEAN]: {
            // componentsType: []
        },
    },
    stringArray: {
        defaultConfig: {
            type: 'enumeration',
            multiOption: true,
            required: false,
            defaultComponent: APP_CHECKBOX,
        },
        [ENUMERATION]: {
            componentsType: [APP_CHECKBOX, APP_DROPDOWN_CHECKBOX, APP_CASCADER],
            multiOptionDisabled: true,
            multiOption: true,
            onlyString: true,
        },
        [IMAGE]: {
            componentsType: [APP_UPLOAD_IMAGE],
            singleImageDisabled: true,
            singleImage: false,
        },
    },
    numberArray: {
        defaultConfig: {
            type: 'enumeration',
            multiOption: true,
            required: false,
            defaultComponent: APP_CHECKBOX,
        },
        [ENUMERATION]: {
            componentsType: [APP_CHECKBOX, APP_DROPDOWN_CHECKBOX, APP_CASCADER],
            multiOptionDisabled: true,
            multiOption: true,
            onlyNumber: true,
        },
    },
    integerArray: {
        defaultConfig: {
            type: 'enumeration',
            multiOption: true,
            required: false,
            defaultComponent: APP_CHECKBOX,
        },
        [ENUMERATION]: {
            componentsType: [APP_CHECKBOX, APP_DROPDOWN_CHECKBOX, APP_CASCADER],
            multiOptionDisabled: true,
            multiOption: true,
            onlyNumber: true,
        },
    },
}

// 具体类型与抽象类型的映射
const ObjectFieldType = [
    {
        type: STRING,
        name: 'string',
    },
    {
        type: NUMBER,
        name: 'number',
    },
    {
        type: ENUMERATION,
        name: 'enumeration',
    },
    {
        type: ENUMERATION,
        name: 'stringArray',
    },
    {
        type: ENUMERATION,
        name: 'numberArray',
    },
    {
        type: BOOLEAN,
        name: 'boolean',
    },
    {
        type: DATE_TIME,
        name: 'dateTime',
    },
    {
        type: DATE_TIME,
        name: 'date',
    },
    {
        type: DATE_TIME,
        name: 'time',
    },
    {
        type: FILE,
        name: 'file',
    },
    {
        type: IMAGE,
        name: 'image',
    },
    // {
    //     name: 'video',
    //     title: '视频',
    // },
    {
        type: OBJECT,
        name: 'object',
    },
    {
        type: OBJECT_ARRAY,
        name: 'objectArray',
    },
]

// 抽象类型合集
const DefaultType = Object.keys(TypeNameMap).reduce((all, key) => ([...all, { type: key, title: TypeNameMap[key] }]), [])
const MockType =  Object.keys(MockTypeNameMap).reduce((all, key) => ([...all, { type: key, title: MockTypeNameMap[key] }]), [])

const DefaultTypeValue = {
    [STRING]: {
        type: 'string',
        // textType: 'short',
        textLengthRange: [0, 200],
        required: false,
        defaultComponent: APP_SINGLE_TEXT,
    },
    [NUMBER]: {
        type: 'number',
        decimalDigit: null,
        minNum: '',
        maxNum: '',
        required: false,
        defaultComponent: APP_NUMBER,
    },
    [ENUMERATION]: {
        type: 'enumeration',
        multiOption: false,
        // optionType: 'customize',
        // options: [{ id: window.crypto.randomUUID(), label: '', value: '' }],
        // defaultChecked: [],
        required: false,
        defaultComponent: APP_RADIO_BUTTONS,
    },
    [BOOLEAN]: {
        type: 'boolean',
        defaultComponent: APP_SWITCH,
    },
    [DATE_TIME]: {
        required: false,
        type: 'dateTime',
        dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
        defaultComponent: APP_DATE_PICKER,
    },
    [IMAGE]: {
        type: 'image',
        required: false,
        maxNum: 9,
        defaultComponent: APP_UPLOAD_IMAGE,
    },
    [OBJECT]: {
        required: false,
        type: 'object',
    },
    [OBJECT_ARRAY]: {
        required: false,
        type: 'objectArray',
    },
    [FILE]: {
        type: 'file',
        required: false,
        maxNum: 10,
        maxSize: 30,
        defaultComponent: APP_ATTACHMENT,
    },
}

// 不同字段类型对应可选组件
const TypeRelatedComponents = {
    [STRING]: [
        { name: APP_SINGLE_TEXT },
        { name: APP_TEXT_AREA },
        { name: APP_RADIO_BUTTONS  },
        { name: APP_DROPDOWN },
        { name: APP_CASCADER },
    ],
    [NUMBER]: [
        // { name: APP_SINGLE_TEXT },
        // { name: APP_TEXT_AREA },
        { name: APP_NUMBER },
        { name: APP_STEPPER },
    ],
    [ENUMERATION]: [
        { name: APP_RADIO_BUTTONS, conditionVal: false, conditionName: 'multiOption' },
        { name: APP_DROPDOWN, conditionVal: false, conditionName: 'multiOption' },
        { name: APP_CHECKBOX, conditionVal: true, conditionName: 'multiOption' },
        { name: APP_DROPDOWN_CHECKBOX, conditionVal: true, conditionName: 'multiOption' },
        { name: APP_CASCADER },
    ],
    [BOOLEAN]: [
        { name: APP_SWITCH },
    ],
    [DATE_TIME]: [
        { name: APP_DATE_PICKER },
    ],
    [IMAGE]: [
        { name: APP_UPLOAD_IMAGE },
        // { name: APP_IMAGE },
    ],
    [FILE]: [
        { name: APP_ATTACHMENT },
    ],

}
// 组件名对应 title
const ComponentsMap = {
    [APP_SINGLE_TEXT]: '单行文本',
    [APP_TEXT_AREA]: '多行文本',
    [APP_NUMBER]: '数值',
    [APP_STEPPER]: '步进器',
    [APP_IMAGE]: '图片',
    [APP_UPLOAD_IMAGE]: '图片上传',
    [APP_SWITCH]: '开关',
    [APP_CASCADER]: '级联单选',
    [APP_DROPDOWN]: '下拉单选',
    [APP_DROPDOWN_CHECKBOX]: '下拉多选',
    [APP_RADIO_BUTTONS]: '单选框',
    [APP_CHECKBOX]: '复选框',
    [APP_DATE_PICKER]: '日期时间选择',
    [APP_ATTACHMENT]: '附件上传',
}

const BaseUrl = 'https://pureui-static.oss-cn-hangzhou.aliyuncs.com/paas-component-system/icon/form-page'
const componentsIcon = {
    [APP_SINGLE_TEXT]: `${BaseUrl}/input.svg`,
    [APP_TEXT_AREA]: `${BaseUrl}/textarea.svg`,
    [APP_NUMBER]: `${BaseUrl}/input-number.svg`,
    [APP_STEPPER]: `${BaseUrl}/stepper.svg`,
    [APP_UPLOAD_IMAGE]: `${BaseUrl}/uploader.svg`,
    [APP_SWITCH]: `${BaseUrl}/switch.svg`,
    [APP_CASCADER]: `${BaseUrl}/cascader.svg`,
    [APP_DROPDOWN]: `${BaseUrl}/selector.svg`,
    [APP_DROPDOWN_CHECKBOX]: `${BaseUrl}/multiple-selector.svg`,
    [APP_RADIO_BUTTONS]: `${BaseUrl}/radio.svg`,
    [APP_CHECKBOX]: `${BaseUrl}/checkbox.svg`,
    [APP_DATE_PICKER]: `${BaseUrl}/date-time-picker.svg`,
    [APP_ATTACHMENT]: `${BaseUrl}/attachment.svg`,
}

export {
    IMAGE,
    STRING,
    OBJECT,
    NUMBER,
    BOOLEAN,
    DATE_TIME,
    ENUMERATION,
    OBJECT_ARRAY,
    FILE,

    DefaultType,
    MockType,
    ObjectFieldType,
    DefaultTypeValue,
    ComponentsMap,
    TypeRelatedComponents,
    ApiTypeFilterMap,
    ApiTypeFilterRules,
    componentsIcon,
}
